import { Component, inject } from '@angular/core';
import { AzureStorageService } from 'src/app/core/services/azure-storage/azure-storage.service';

@Component({
  selector: 'app-storage',
  templateUrl: './storage.component.html',
  styleUrls: ['./storage.component.scss'],
})
export class StorageComponent {
  private storage = inject(AzureStorageService);

  /**
   * Last blob url uploaded
   */
  blobUrl = '';

  /**
   * File select handler to upload the file to the storage
   *
   * @param event File Select event
   */
  async uploadFile(event) {
    const file: File = event.target.files[0];
    if (file) {
      console.log('Upload file');
      console.log(file);

      const fileName = file.name.replace(' ', '-');
      const time = new Date().getTime();
      const uniqueName = `${time}_${fileName}`;

      console.log(`${uniqueName}`);
      const fileUrl = await this.storage.uploadBlob(file, uniqueName);

      if (fileUrl) {
        // Request to playfab

        this.blobUrl = fileUrl;
        console.log(fileUrl);
      }
    }
  }

  /**
   * Retrieve a blob info from the storage
   */
  async loadBlob() {
    if (this.blobUrl) {
      const fileBlob = await this.storage.getBlobFromUrl(this.blobUrl);

      console.log('Here is your blob');
      console.log(fileBlob);
    }
  }
}
